<div class="row" *ngIf="account$ | async as account">
  <div class="col-12 col-sm-9">
    <h1>Mina organisationer</h1>
    <div
      class="text-muted fst-italic"
      *ngIf="(isLoadingOrganizations$ | async) && account.organizations && account.organizations.length > 0">
      <span class="align-middle" *ngIf="account.organizations && account.organizations.length === 1"
        >Laddar din organisation...</span
      >
      <span class="align-middle" *ngIf="account.organizations && account.organizations.length > 1"
        >Laddar dina organisationer...</span
      >
    </div>

    <ng-container *ngIf="organizations">
      <div class="alert alert-info" *ngIf="organizations.length === 0">
        Du har inte tillgång till någon organisation ännu. Registrera er organisation eller hitta en befintlig och begär
        rättigheter
      </div>
      <ng-container *ngFor="let organization of organizations">
        <div
          tabindex="0"
          class="mt-4 alert alert-light border"
          (click)="view(organization)"
          (keydown)="$event.target.click()"
          [ngClass]="{
            pointer: organization.verified,
            'border-secondary': !organization.verified,
            'border-success': organization.verified,
            'border-dark': organization.removeDate,
            'bg-warning': organization.removeDate,
            'fst-italic': !organization.verified,
          }">
          <div class="d-flex align-items-center">
            <img
              *ngIf="organization.logoUrl"
              [src]="organization.logoUrl"
              style="width: 50px"
              alt="{{ organization.name }}'s logo" />
            <h5 class="mb-0" [ngClass]="{ 'ms-2': organization.logoUrl }">{{ organization.name }}</h5>
          </div>
          <small *ngIf="!organization.verified" class="d-flex align-items-center mt-2"
            ><span class="material-icons me-1">hourglass_empty</span> Väntar på godkännande...</small
          >
          <small *ngIf="organization.removeDate" class="d-flex align-items-center mt-2"
            ><span class="material-icons me-1">auto_delete</span>Organisationen raderas
            {{ organization.removeDate | date: friendlyDateTimeWithDayShort }}</small
          >
        </div>
        <div
          tabindex="0"
          *ngFor="let child of organization.childOrganizations"
          class="ms-4 mt-4 alert alert-light border"
          (click)="view(child)"
          (keydown)="$event.target.click()"
          [ngClass]="{
            pointer: child.verified,
            'border-secondary': !child.verified,
            'border-success': child.verified,
            'border-dark': child.removeDate,
            'bg-warning': child.removeDate,
            'fst-italic': !child.verified,
          }">
          <h5 [ngClass]="{ 'mb-0': child.verified }">
            <img *ngIf="child.logoUrl" [src]="child.logoUrl" style="width: 50px" alt="{{ child.name }}'s logo" />
            {{ child.name }}
          </h5>
          <small *ngIf="!child.verified" class="d-flex align-items-center mt-2"
            ><span class="material-icons me-1">hourglass_empty</span> Väntar på godkännande...</small
          >
          <small *ngIf="child.removeDate" class="d-flex align-items-center mt-2"
            ><span class="material-icons me-1">auto_delete</span>Organisationen raderas
            {{ child.removeDate | date: friendlyDateTimeWithDayShort }}</small
          >
        </div>
      </ng-container>
    </ng-container>
  </div>
  <div class="col-12 col-sm-3 mb-4 mb-sm-0">
    <button class="btn btn-primary w-100" [routerLink]="['organization/search']">
      <span class="material-icons">search</span><span class="align-middle">Sök organisation</span>
    </button>

    <button class="btn btn-primary mt-2 w-100" [routerLink]="['organization/register']">
      <span class="material-icons align-middle">add</span><span class="align-middle">Registrera ny organisation</span>
    </button>
  </div>
</div>
